import { getAxiosTotall} from "./ApiInstance"

//////////////// Get Api //////////////////////////////////
export const SalesRepoartApi=async () => {
    try{
        const result =await getAxiosTotall().get(`statistics/sells/`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const getCategoryListApi=async () => {
    try{
        const result =await getAxiosTotall().get(`category/all/`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const ReceivedOrdersAPI=async () => {
    try{
        const result =await getAxiosTotall().get(`orders/new/`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const OrderspreparedAPI=async () => {
    try{
        const result =await getAxiosTotall().get(`orders/pending/`);
        return result.data;
    }catch (error){
        return error;
    }
};
export const orderListDetailApi=async (id) => {
    try{
        const result =await getAxiosTotall().get(`orders/detail/${id}`);
        return result.data;
    }catch (error){
        return error;
    }
}
export const getSupperMarketProductAPI=async () => {
    try{
        const result =await getAxiosTotall().get(`products/supermarket/`);
        return result.data;
    }catch (error){
        return error;
    }
};

export const getComentInfoAPI=async () => {
    try{
        const result =await getAxiosTotall().get(`comments/`);
        return result.data;
    }catch (error){
        return error;
    }
}
export const getBrandListApi=async () => {
    try{ 
        const result =await getAxiosTotall().get('brand/');
        return result.data;
    }catch (error){
        return error;
    }
}
export const getSearchProductsApi=async (value) => {
    try{
        const result =await getAxiosTotall().get(`products/search/?q=${value}`);
        return result.data;
    }catch (error){
        return error;
    }
}
export const getDeliverInfoApi=async(orderId) => {
    try{
        const result =await getAxiosTotall().get(`orders/deliveryinfo/?id=${orderId}`);
        return result.data;
    }catch (error){
        return error;
    }
}
export const getSupplierCustomersApi=async() => {
    try{
        const result =await getAxiosTotall().get('my_customer/');
        return result.data;
    }catch (error){
        return error;
    }
}
export const getAcountinListApi=async() => {
    try{
        const result =await getAxiosTotall().get('accounting/all/');
        return result.data;
    }catch (error){
        return error;
    }
}
export const getWalletApi=async() => {
    try{
        const result =await getAxiosTotall().get('accounting/wallet/');
        return result.data;
    }catch (error){
        return error;
    }
}
export const getDeliverLocaApi=async (orderId) => {
    try{
        const result =await getAxiosTotall().get(`orders/location/?id=${orderId}`);
        return result.data;
    }catch (error){
        return error;
    }
}
////////////////// Post Api //////////////////////

export const SupplierLoginPhoneNumber=(info, callback)=>{
    getAxiosTotall().post("login/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const SupplierCheckCodeAPI=(info, callback)=>{
    getAxiosTotall().post("login/verification/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const setTimePreparationAPI=(info, callback)=>{
    getAxiosTotall().post("orders/new/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const orderRepoartsApi=(info, callback)=>{
    getAxiosTotall().post("orders/all/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const ProductsRepoartApi=(info, callback)=>{
    getAxiosTotall().post("orders/products/", info).then(response =>{
            callback(response.data); 
        }).catch(error => {
            callback(error.data);
        })
};
export const AddProductToMenuAPI=(info, callback)=>{
    getAxiosTotall().post("category/add/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const RemoveMenuSupplierAPI=(info, callback)=>{
    getAxiosTotall().post("category/remove/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const EditMenuAPI=(info, callback)=>{
    getAxiosTotall().post("category/update/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};

export const AddProductSuppermarketAPI=(info, callback)=>{
    getAxiosTotall().post("products/add/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
}; 
export const ReplyCommentAPI=(info, callback)=>{
    getAxiosTotall().post("comments/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const AddBrandPostApi=(info, callback)=>{
    getAxiosTotall().post("brand/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const requestSupplierPostApi=(info, callback)=>{
    getAxiosTotall().post("join_us/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};

export const addCustomerPostApi=(info, callback)=>{
    getAxiosTotall().post("my_customer/add/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const deleteProductPostApi=(info, callback)=>{
    getAxiosTotall().post("products/remove/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};